module.exports = __webpack_public_path__ + "img/DC-appointments-award.2d585f67.svg";